<script>
import EventBus from '~/EventBus'

import themeStore from '~/plugins/themestore'

export default {
  props: {
    height: {
      type: String,
      required: false,
      default: '40px',
    },
  },
  data() {
    return {
      dataTemplateId: '5419b6ffb0d04a076446a9af',
    }
  },
  computed: {
    themeType() {
      return themeStore.type
    },
  },
  watch: {
    themeType: {
      handler: 'refreshWidget',
      immediate: true,
    },
  },
  mounted: function () {
    EventBus.$on('load-trust-pilot-widget', (options = { loadMicroStar: false }) => {
      if (options.loadMicroStar) {
        this.dataTemplateId = '5419b732fbfb950b10de65e5'
      }
      this.showTrustBoxWidget()
    })
  },
  methods: {
    showTrustBoxWidget() {
      const trustBox = this.$refs.trustpilotWidgetBox
      if (window.Trustpilot && trustBox) {
        window.Trustpilot.loadFromElement(trustBox)
      }
    },
    refreshWidget() {
      this.$nextTick(() => {
        if (window.Trustpilot) {
          window.Trustpilot.Modules.WidgetManagement.removeWidget(this.$refs.trustpilotWidgetBox)
          window.Trustpilot.Modules.WidgetManagement.createWidget(this.$refs.trustpilotWidgetBox)
        }
      })
    },
  },
}
</script>

<template>
  <div class="trustpilot-div">
    <!-- TrustBox widget - Micro Combo -->
    <div
      ref="trustpilotWidgetBox"
      class="trustpilot-widget"
      data-locale="en-US"
      :data-template-id="dataTemplateId"
      data-businessunit-id="5e4fb39b38d2d60001f5e904"
      :data-style-height="height"
      data-style-width="100%"
      :data-theme="themeType"
    >
      <a
        href="https://www.trustpilot.com/review/zendrop.com"
        target="_blank"
        rel="noopener"
      >
        Trustpilot
      </a>
    </div>
    <!-- End TrustBox widget -->
  </div>
</template>
